module.exports = __webpack_public_path__ + "static/media/wormhole.70fec324.jpg";